<div class="chat">
  <div class="header" *ngIf="bot">
    <div class="header-content">
      <h1>{{ bot.name }}</h1>
      <div class="header-actions">
        <div class="scheduling-toggle" *ngIf="schedulingEnabled && !experimentalVariant">
          <label class="toggle-label">
            <input type="checkbox" [checked]="schedulingMode" (change)="toggleSchedulingMode()" />
            <span class="toggle-text">Agendamiento</span>
          </label>
        </div>
        <div class="experimental-selector">
          <p-dropdown
            [options]="experimentalVariantOptions"
            [ngModel]="experimentalVariant"
            (ngModelChange)="setExperimentalVariant($event)"
            optionLabel="label"
            optionValue="value"
            placeholder="Legacy"
            styleClass="exp-dropdown"
          ></p-dropdown>
        </div>
        <i
          class="pi pi-refresh"
          (click)="clearChat()"
          style="font-size: 1.4rem"
          aria-label="Reiniciar conversación"
        ></i>
      </div>
    </div>
    <hr />
  </div>
  <div class="panel" #scrollMe [scrollTop]="scrollMe.scrollHeight">
    <div class="chat-container" #chatContainer>
      <div *ngFor="let msg of chatHistory; trackBy: trackByIndex" [class]="['msg-' + msg.type]">
        <span *ngIf="msg.type === 'loading'; else message">
          <img src="assets/loading-chat.svg" alt="load" height="40" />
        </span>
        <ng-template #message>
          <markdown [data]="msg.message" class="markdown-content"></markdown>
          <!-- Scheduling metadata badge -->
          <div class="scheduling-meta" *ngIf="msg.scheduling && msg.type === 'bot'">
            <span class="meta-badge intent" *ngIf="msg.scheduling.intent">
              {{ msg.scheduling.intent }}
            </span>
            <span class="meta-badge action" *ngIf="msg.scheduling.action_taken">
              {{ msg.scheduling.action_taken }}
            </span>
            <span class="meta-badge awaiting" *ngIf="msg.scheduling.awaiting_input">
              esperando: {{ msg.scheduling.awaiting_input }}
            </span>
            <span class="meta-badge error" *ngIf="msg.scheduling.error_code">
              {{ msg.scheduling.error_code }}
            </span>
          </div>
        </ng-template>
      </div>
      <div class="msg-bot" *ngIf="haveError">
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g id="exclamation-triangle">
            <g id="&#60;Path&#62;">
              <path
                id="Vector"
                d="M16.9999 15.75H0.999928C0.868876 15.7496 0.740155 15.7153 0.626262 15.6505C0.51237 15.5857 0.417177 15.4925 0.349927 15.38C0.285999 15.2653 0.252441 15.1363 0.252441 15.005C0.252441 14.8737 0.285999 14.7446 0.349927 14.63L8.34993 0.629997C8.42108 0.522734 8.51767 0.434746 8.63108 0.373879C8.7445 0.313012 8.87121 0.281158 8.99993 0.281158C9.12864 0.281158 9.25536 0.313012 9.36877 0.373879C9.48219 0.434746 9.57878 0.522734 9.64993 0.629997L17.6499 14.63C17.7139 14.7446 17.7474 14.8737 17.7474 15.005C17.7474 15.1363 17.7139 15.2653 17.6499 15.38C17.5827 15.4925 17.4875 15.5857 17.3736 15.6505C17.2597 15.7153 17.131 15.7496 16.9999 15.75ZM2.28993 14.25H15.7099L8.99993 2.51L2.28993 14.25Z"
                fill="#CC8925"
              />
            </g>
            <path
              id="Vector_2"
              d="M9 10.25C8.80189 10.2474 8.61263 10.1676 8.47253 10.0275C8.33244 9.88737 8.25259 9.69811 8.25 9.5V6C8.25 5.80109 8.32902 5.61032 8.46967 5.46967C8.61032 5.32902 8.80109 5.25 9 5.25C9.19891 5.25 9.38968 5.32902 9.53033 5.46967C9.67098 5.61032 9.75 5.80109 9.75 6V9.5C9.74741 9.69811 9.66756 9.88737 9.52747 10.0275C9.38737 10.1676 9.19811 10.2474 9 10.25Z"
              fill="#CC8925"
            />
            <path
              id="Vector_3"
              d="M9 13.25C8.80189 13.2474 8.61263 13.1676 8.47253 13.0275C8.33244 12.8874 8.25259 12.6981 8.25 12.5V12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25C9.19891 11.25 9.38968 11.329 9.53033 11.4697C9.67098 11.6103 9.75 11.8011 9.75 12V12.5C9.74741 12.6981 9.66756 12.8874 9.52747 13.0275C9.38737 13.1676 9.19811 13.2474 9 13.25Z"
              fill="#CC8925"
            />
          </g>
        </svg>
        Tengo problemas al procesar tu pregunta. Por favor, intenta de nuevo.
      </div>
      <div class="msg-bot" *ngIf="subscriptionLimitReached">
        <svg
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g id="exclamation-triangle">
            <g id="&#60;Path&#62;">
              <path
                id="Vector"
                d="M16.9999 15.75H0.999928C0.868876 15.7496 0.740155 15.7153 0.626262 15.6505C0.51237 15.5857 0.417177 15.4925 0.349927 15.38C0.285999 15.2653 0.252441 15.1363 0.252441 15.005C0.252441 14.8737 0.285999 14.7446 0.349927 14.63L8.34993 0.629997C8.42108 0.522734 8.51767 0.434746 8.63108 0.373879C8.7445 0.313012 8.87121 0.281158 8.99993 0.281158C9.12864 0.281158 9.25536 0.313012 9.36877 0.373879C9.48219 0.434746 9.57878 0.522734 9.64993 0.629997L17.6499 14.63C17.7139 14.7446 17.7474 14.8737 17.7474 15.005C17.7474 15.1363 17.7139 15.2653 17.6499 15.38C17.5827 15.4925 17.4875 15.5857 17.3736 15.6505C17.2597 15.7153 17.131 15.7496 16.9999 15.75ZM2.28993 14.25H15.7099L8.99993 2.51L2.28993 14.25Z"
                fill="#CC8925"
              />
            </g>
            <path
              id="Vector_2"
              d="M9 10.25C8.80189 10.2474 8.61263 10.1676 8.47253 10.0275C8.33244 9.88737 8.25259 9.69811 8.25 9.5V6C8.25 5.80109 8.32902 5.61032 8.46967 5.46967C8.61032 5.32902 8.80109 5.25 9 5.25C9.19891 5.25 9.38968 5.32902 9.53033 5.46967C9.67098 5.61032 9.75 5.80109 9.75 6V9.5C9.74741 9.69811 9.66756 9.88737 9.52747 10.0275C9.38737 10.1676 9.19811 10.2474 9 10.25Z"
              fill="#CC8925"
            />
            <path
              id="Vector_3"
              d="M9 13.25C8.80189 13.2474 8.61263 13.1676 8.47253 13.0275C8.33244 12.8874 8.25259 12.6981 8.25 12.5V12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25C9.19891 11.25 9.38968 11.329 9.53033 11.4697C9.67098 11.6103 9.75 11.8011 9.75 12V12.5C9.74741 12.6981 9.66756 12.8874 9.52747 13.0275C9.38737 13.1676 9.19811 13.2474 9 13.25Z"
              fill="#CC8925"
            />
          </g>
        </svg>
        Superaste el límite de 20 mensajes mensuales de tu plan actual. Suscríbete para realizar más
        consultas.
      </div>
    </div>
    <button style="margin-left: 10px" type="button" pButton (click)="reset()" *ngIf="haveError">
      Reintentar
    </button>
    <button
      style="margin-left: 10px"
      type="button"
      pButton
      *ngIf="subscriptionLimitReached"
      onclick="window.open('https://globot.ai/precios/', '_blank')"
    >
      Suscribirse ahora
    </button>
  </div>

  <div class="message-input">
    <div class="input-wrapper">
      <span class="exp-badge" *ngIf="experimentalVariant">EXP-{{ experimentalVariant }}</span>
      <input
        type="text"
        pInputText
        [disabled]="haveError"
        (keyup.enter)="sendQuestion()"
        [placeholder]="
          experimentalVariant
            ? 'Modo experimental ' + experimentalVariant + '...'
            : schedulingMode
            ? 'Prueba el agendamiento...'
            : 'Escribe tu pregunta aquí...'
        "
        [(ngModel)]="currentQuestion"
      />
    </div>
    <button
      type="button"
      pButton
      [disabled]="haveError"
      (click)="sendQuestion()"
      pRipple
      label=""
      icon="pi pi-send"
      iconPos="right"
      aria-label="Enviar pregunta"
    ></button>
  </div>
  <div class="generated-text">
    Generado por <a style="cursor: pointer" href="https://globot.ai/" target="_blank">Globot</a>
  </div>
</div>
